import React from 'react';

/**
 * "A new version is ready" (24 Sep 2026).
 *
 * Only ever shown when Portal OS was published WHILE this window was open — a
 * stale shell found at boot reloads itself silently instead, since nothing is
 * in flight one second after load. See utils/appVersion.ts.
 *
 * It does not reload on its own and it cannot be dismissed. Not dismissible
 * because the alternative is somebody working all afternoon in a version that
 * no longer matches the database; not automatic because the person it would
 * interrupt is the one halfway through a call sheet. Offering the choice is
 * the only option that cannot lose work.
 *
 * Fixed to the top rather than the bottom: the bottom belongs to the tab bar
 * on a phone, and a notice that has to be read should not have to compete
 * with the thing you navigate with.
 */
export function UpdateBar() {
  return <div className="fixed inset-x-0 top-0 z-40 border-b border-ruleDark bg-ink pt-safe" data-id="element-1675" data-mp="p6bj6lfnbes6">
      <div className="mx-auto flex max-w-portal items-center justify-between gap-6 px-6 py-3 sm:px-10" data-id="element-1676" data-mp="u54wacr0t3rt">
        <span className="label-sm text-paper/60" data-id="element-1677" data-mp="2vcb47w8gabtq">A new version of Portal OS is ready</span>
        <button type="button" onClick={() => window.location.reload()} className="label -mr-2 inline-flex h-11 items-center px-2 text-paper transition-opacity duration-150 ease-out hover:opacity-70" data-id="element-1678" data-mp="2qdhpy1lcagsi">
          Reload
        </button>
      </div>
    </div>;
}